import { useQuery } from "react-query";
import { apiConnectorPost } from "../../../utils/APIConnector";
import { endpoint } from "../../../utils/APIRoutes";
import CustomToPagination from "../../../Shared/Pagination";
import React from "react";
import TradingAccountCard from "./PammCard";
export default function ClientAccounts() {
  const today = new Date().toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  const [page, setPage] = React.useState(1);
  const pageSize = 18;

  const { data, isLoading, isFetching } = useQuery(
    [
      "get_all_mt5_account_details",
      page,
      pageSize,
    ],
    () =>
      apiConnectorPost(endpoint?.get_all_mt5_account_details, {
        page: page,
        count: pageSize,
      }),
    {
      keepPreviousData: true,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      onError: (err) => console.error("Error fetching direct data:", err),
    }
  );

  const get_mt_account = data?.data?.result || [];
  const accountList = get_mt_account?.data || [];
  const showSkeleton = isLoading || (isFetching && accountList?.length === 0);
  const skeletonCards = Array.from({ length: 6 });

  const toDisplayValue = (value, fallback = "0.00") => {
    if (value === null || value === undefined || value === "") {
      return fallback;
    }
    const numericValue = Number(String(value).replace(/,/g, "").trim());
    if (Number.isFinite(numericValue)) {
      return numericValue.toFixed(2);
    }
    return String(value);
  };
  return (
    <>
      <style>{style}</style>
      <div className="dashboard">
        <div className="orb orb-1" /><div className="orb orb-2" /><div className="orb orb-3" />
        <div className="grain" />
        <div className="content">

          {/* Header */}
          <div className="header">
            <div className="header-left">
              <span className="header-label">Client Account Overview</span>
              <h1 className="header-title">Client Accounts</h1>
            </div>
            <div className="header-right">
              <div className="badge"><div className="badge-dot" /> Live</div>
              <div className="date-chip">{today}</div>
            </div>
          </div>


          <div className="grid lg:grid-cols-3 grid-cols-1 gap-3">
            {showSkeleton ? (
              skeletonCards.map((_, index) => (
                <div key={`account-skeleton-${index}`} className="account-skeleton" />
              ))
            ) : (
              accountList?.map((account, index) => (
              <TradingAccountCard
                key={account?.tr03_mt_trd_id || account?.tdr_name || index}
                platform={account?.tr03_mt_trd_server ? "ONEPLUS" : "ONEPLUS"}
                accountId={account?.tr03_cust_id || "N/A"}
                leverage={toDisplayValue(account?.tdr_equity)}
                accountType={toDisplayValue(account?.total_payout) || "N/A"}
                // accountType={account?.tdr_name || "N/A"}
                server={"Oneplus.tech"}
                balance={toDisplayValue(account?.tr03_topup_wallet)}
                currentPayout={toDisplayValue(account?.tr03_inc_wallet)}
                currency={account?.tdr_currency || "USD"}
                credits={toDisplayValue(account?.tr03_total_income)}
                isActive
                flagEmoji="🇺🇸"
              />
              ))
            )}

          </div>
          {!showSkeleton && accountList?.length > 0 && (
            <CustomToPagination setPage={setPage} page={page} data={get_mt_account} />
          )}
        </div>
      </div>
    </>
  );
}

const style = `
  * { margin: 0; padding: 0; box-sizing: border-box; }

  :root {
    --bg: #09090f;
    --surface: #111118;
    --surface2: #16161f;
    --border: rgba(255,255,255,0.07);
    --border-glow: rgba(99,102,241,0.3);
    --accent: #6366f1;
    --accent2: #22d3ee;
    --accent3: #f472b6;
    --gold: #fed603;
    --text-primary: #f1f5f9;
    --text-secondary: #64748b;
    --text-muted: #334155;
    --green: #20aaca;
    --red: #f43f5e;
    --font: Verdana, Geneva, Tahoma, sans-serif;
  }

  body {
    background: var(--bg);
    font-family: var(--font);
    color: var(--text-primary);
    min-height: 100vh;
    overflow-x: hidden;
  }

  * {
    scrollbar-width: thin;
    scrollbar-color: #22d3ee rgba(34,211,238,0.12);
  }

  *::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  *::-webkit-scrollbar-track {
    background: rgba(34,211,238,0.12);
    border-radius: 10px;
  }

  *::-webkit-scrollbar-thumb {
    background: linear-gradient(180deg, #67e8f9, #22d3ee);
    border-radius: 10px;
    border: 2px solid rgba(9,9,15,0.65);
  }

  *::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(180deg, #a5f3fc, #22d3ee);
  }

  .dashboard {
    min-height: 100vh;
    background: var(--bg);
    position: relative;
    overflow: hidden;
  }

  /* Ambient orbs */
  .orb {
    position: fixed;
    border-radius: 50%;
    filter: blur(120px);
    pointer-events: none;
    z-index: 0;
  }
  .orb-1 { width: 600px; height: 600px; background: rgba(99,102,241,0.08); top: -200px; right: -200px; }
  .orb-2 { width: 500px; height: 500px; background: rgba(34,211,238,0.05); bottom: -150px; left: -150px; }
  .orb-3 { width: 400px; height: 400px; background: rgba(244,114,182,0.04); top: 40%; left: 40%; }

  /* Grain overlay */
  .grain {
    position: fixed; inset: 0; z-index: 1; pointer-events: none; opacity: 0.025;
    background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E");
  }

  .content {
    position: relative; z-index: 2;
    max-width: 1400px;
    margin: 0 auto;
    padding: 32px 40px 60px;
  }

  .account-skeleton {
    height: 286px;
    border-radius: 16px;
    border: 1px solid rgba(32,170,202,0.22);
    background:
      linear-gradient(110deg, rgba(20,184,166,0.08) 8%, rgba(94,234,212,0.2) 18%, rgba(20,184,166,0.08) 33%),
      linear-gradient(145deg, rgba(5,10,12,0.98), rgba(8,16,20,0.98));
    background-size: 220% 100%, 100% 100%;
    animation: accountShimmer 1.2s linear infinite;
  }

  /* Header */
  .header {
    display: flex; align-items: center; justify-content: space-between;
    flex-wrap: wrap; gap: 16px;
    margin-bottom: 48px;
    padding-bottom: 24px;
    border-bottom: 1px solid var(--border);
    animation: fadeDown 0.6s ease both;
  }

  .header-left { display: flex; flex-direction: column; gap: 4px; }

  .header-label {
    font-family: var(--font);
    font-size: 10px; letter-spacing: 0.18em; text-transform: uppercase;
    color: var(--accent); font-weight: 700;
  }

  .header-title {
    font-size: 26px; font-weight: 700; letter-spacing: -0.3px;
    background: linear-gradient(135deg, #f1f5f9 0%, #94a3b8 100%);
    -webkit-background-clip: text; -webkit-text-fill-color: transparent;
  }

  .header-right { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; }

  .premium-section {
    margin-bottom: 24px;
    animation: fadeUp 0.6s ease 0.05s both;
  }

  .premium-title-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 12px;
  }

  .premium-title-dot {
    width: 8px;
    height: 8px;
    border-radius: 999px;
    background: linear-gradient(135deg, #5bcde6, #20aaca);
    box-shadow: 0 0 16px rgba(32,170,202,0.5);
  }

  .premium-title {
    font-size: 12px;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    font-weight: 700;
    color: #99ebff;
  }

  .premium-title-line {
    flex: 1;
    height: 1px;
    background: linear-gradient(90deg, rgba(32,170,202,0.35), transparent);
  }

  .premium-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
  }

  .premium-card {
    position: relative;
    overflow: hidden;
    border-radius: 14px;
    padding: 14px;
    background: linear-gradient(145deg, rgba(10,18,25,0.95), rgba(11,22,17,0.95));
    border: 1px solid rgba(32,170,202,0.16);
    box-shadow: 0 8px 28px rgba(0,0,0,0.35), inset 0 1px 0 rgba(32,170,202,0.08);
    transition: transform .2s ease, border-color .2s ease;
  }

  .premium-card:hover {
    transform: translateY(-2px);
    border-color: rgba(32,170,202,0.35);
  }

  .premium-card-glow {
    position: absolute;
    top: -20px;
    right: -20px;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(32,170,202,0.16) 0%, transparent 70%);
    pointer-events: none;
  }

  .premium-card-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    gap: 8px;
  }

  .premium-card-label {
    font-size: 9px;
    color: #64748b;
    letter-spacing: .11em;
    text-transform: uppercase;
    font-weight: 700;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .premium-card-index {
    font-size: 9px;
    font-weight: 700;
    color: #99ebff;
    border: 1px solid rgba(32,170,202,0.2);
    background: rgba(32,170,202,0.08);
    border-radius: 999px;
    padding: 2px 6px;
    flex-shrink: 0;
  }

  .premium-card-value {
    font-size: 20px;
    font-weight: 700;
    letter-spacing: -0.02em;
    background: linear-gradient(135deg, #d2f4fb 0%, #99ebff 55%, #20aaca 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-bottom: 10px;
    font-variant-numeric: tabular-nums;
  }

  .premium-card-bar {
    height: 4px;
    border-radius: 999px;
    background: rgba(32,170,202,0.12);
    overflow: hidden;
  }

  .premium-card-fill {
    display: block;
    height: 100%;
    width: 55%;
    border-radius: 999px;
    background: linear-gradient(90deg, #20aaca, #5bcde6);
  }

  .badge {
    display: flex; align-items: center; gap: 6px;
    padding: 6px 14px; border-radius: 100px;
    background: rgba(32,170,202,0.1);
    border: 1px solid rgba(32,170,202,0.2);
    font-family: var(--font); font-size: 10px;
    color: var(--green); letter-spacing: 0.05em; font-weight: 700;
  }
  .badge-dot {
    width: 6px; height: 6px; border-radius: 50%; background: var(--green);
    animation: pulse-dot 2s ease infinite;
  }

  .date-chip {
    padding: 6px 14px; border-radius: 100px;
    background: var(--surface2); border: 1px solid var(--border);
    font-family: var(--font); font-size: 10px;
    color: var(--text-secondary);
  }

  /* KPI Grid */
  .kpi-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    margin-bottom: 24px;
  }

  .kpi-card {
    position: relative; overflow: hidden;
    background: linear-gradient(145deg, rgba(5, 10, 12, 0.98), rgba(8, 16, 20, 0.98));
    border: 1px solid rgba(32,170,202,0.45);
    color: #20aaca;
    box-shadow: 0 10px 30px rgba(32,170,202,0.2), inset 0 1px 0 rgba(91,205,230,0.12);
    border-radius: 16px;
    padding: 24px;
    transition: border-color 0.3s, transform 0.3s;
    animation: fadeUp 0.6s ease both;
  }
  .kpi-card:hover {
    border-color: rgba(91,205,230,0.8);
    transform: translateY(-2px);
  }
  .kpi-card::before {
    content: ''; position: absolute; inset: 0;
    background: linear-gradient(135deg, rgba(255,255,255,0.02) 0%, transparent 60%);
    pointer-events: none;
  }

  .kpi-card--deposit { --card-accent: var(--green); }
  .kpi-card--withdrawal { --card-accent: #2eadf2; }
  .kpi-card--balance { --card-accent: var(--accent); }
  .kpi-card--profit { --card-accent: var(--gold); }
  .kpi-card--users { --card-accent: var(--accent2); }

  .kpi-card::after {
    content: ''; position: absolute;
    top: 0; left: 0; right: 0; height: 1px;
    background: linear-gradient(90deg, transparent, var(--card-accent), transparent);
    opacity: 0.6;
  }

  .kpi-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px; }

  .kpi-icon {
    width: 36px; height: 36px; border-radius: 10px;
    display: flex; align-items: center; justify-content: center;
    background: rgba(32,170,202,0.14);
    border: 1px solid rgba(32,170,202,0.35);
    font-size: 16px;
  }

  .kpi-trend {
    display: flex; align-items: center; gap: 4px;
    font-family: var(--font); font-size: 10px; font-weight: 700;
    padding: 3px 8px; border-radius: 6px;
  }
  .kpi-trend--up { color: var(--green); background: rgba(32,170,202,0.1); }
  .kpi-trend--down { color: var(--red); background: rgba(244,63,94,0.1); }

  .kpi-label {
    font-family: var(--font); font-size: 10px; letter-spacing: 0.09em;
    text-transform: uppercase; color: #99ebff; margin-bottom: 8px; font-weight: 700;
  }

  .kpi-value {
    font-size: 28px; font-weight: 700; letter-spacing: -0.5px;
    color: #20aaca;
    font-variant-numeric: tabular-nums;
  }

  .kpi-sub {
    font-family: var(--font); font-size: 10px;
    color: #b9f2ff; margin-top: 6px;
  }

  /* Middle row */
  .mid-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 340px;
    gap: 16px;
    margin-bottom: 24px;
  }

  /* Chart card */
  .chart-card {
    background: linear-gradient(145deg, rgba(5, 10, 12, 0.98), rgba(8, 16, 20, 0.98)); border: 1px solid rgba(32,170,202,0.45);
    color: #20aaca;
    box-shadow: 0 10px 30px rgba(32,170,202,0.2), inset 0 1px 0 rgba(91,205,230,0.12);
    border-radius: 16px; padding: 28px;
    animation: fadeUp 0.7s ease 0.1s both;
  }

  .card-title-row {
    display: flex; align-items: flex-start; justify-content: space-between;
    flex-wrap: wrap; gap: 10px;
    margin-bottom: 24px;
  }

  .card-title {
    font-size: 14px; font-weight: 700; letter-spacing: -0.1px;
    color: #20aaca;
  }
  .card-subtitle {
    font-family: var(--font); font-size: 10px;
    color: #b9f2ff; margin-top: 3px;
  }

  .chart-card .apexcharts-legend-text,
  .chart-card .apexcharts-text,
  .chart-card .apexcharts-datalabel-label,
  .chart-card .apexcharts-datalabel-value {
    fill: #20aaca !important;
    color: #20aaca !important;
  }

  .chart-wrap,
  .pie-wrap {
    width: 100%;
    overflow: visible;
    touch-action: manipulation;
  }

  #chart,
  .pie-wrap {
    position: relative;
    z-index: 2;
  }

  .chart-wrap .apexcharts-canvas,
  .pie-wrap .apexcharts-canvas {
    max-width: 100% !important;
  }

  .pill-tabs { display: flex; gap: 4px; }
  .pill-tab {
    padding: 5px 12px; border-radius: 8px;
    font-family: var(--font); font-size: 10px; font-weight: 700;
    cursor: pointer; border: none; transition: all 0.2s;
    color: var(--text-secondary); background: transparent;
  }
  .pill-tab.active { background: var(--accent); color: white; }

  /* Bar chart */
  .bar-chart {
    display: flex; align-items: flex-end; gap: 8px; height: 140px;
  }
  .bar-group { display: flex; gap: 3px; align-items: flex-end; flex: 1; }
  .bar {
    flex: 1; border-radius: 4px 4px 0 0;
    transition: opacity 0.2s;
    position: relative; cursor: pointer;
  }
  .bar:hover { opacity: 0.8; }
  .bar--deposit { background: linear-gradient(180deg, var(--green) 0%, rgba(32,170,202,0.3) 100%); }
  .bar--withdrawal { background: linear-gradient(180deg, var(--red) 0%, rgba(244,63,94,0.3) 100%); }

  .bar-labels {
    display: flex; gap: 8px; margin-top: 12px;
  }
  .bar-label {
    flex: 1; text-align: center;
    font-family: var(--font); font-size: 10px; color: var(--text-muted);
  }

  .apexcharts-tooltip {
    background: #fed603 !important;
    color: #111118 !important;
    border: 1px solid #d4b200 !important;
    box-shadow: 0 6px 20px rgba(254, 214, 3, 0.25) !important;
    z-index: 9999 !important;
    pointer-events: none !important;
  }
  .apexcharts-tooltip-title {
    background: #f5cf00 !important;
    color: #111118 !important;
    border-bottom: 1px solid #d4b200 !important;
  }
  .apexcharts-tooltip-text-y-label,
  .apexcharts-tooltip-text-y-value,
  .apexcharts-tooltip-text-z-label,
  .apexcharts-tooltip-text-z-value {
    color: #111118 !important;
  }

  /* Donut */
  .donut-wrap { display: flex; align-items: center; gap: 24px; margin-top: 8px; flex-wrap: wrap; justify-content: center; }
  .donut-svg { flex-shrink: 0; }
  .donut-legend { display: flex; flex-direction: column; gap: 12px; }
  .legend-item { display: flex; align-items: center; gap: 8px; }
  .legend-dot { width: 8px; height: 8px; border-radius: 2px; flex-shrink: 0; }
  .legend-label { font-family: var(--font); font-size: 10px; color: var(--text-secondary); }
  .legend-val { font-size: 12px; font-weight: 700; color: var(--text-primary); margin-top: 1px; }

  /* Activity feed */
  .feed-card {
    background: var(--surface); border: 1px solid var(--border);
    border-radius: 16px; padding: 28px;
    animation: fadeUp 0.7s ease 0.15s both;
  }

  .feed-list { display: flex; flex-direction: column; gap: 14px; margin-top: 4px; }

  .feed-item {
    display: flex; align-items: center; gap: 12px;
    padding: 10px; border-radius: 10px;
    transition: background 0.2s; cursor: pointer;
    border: 1px solid transparent;
  }
  .feed-item:hover { background: rgba(255,255,255,0.03); }
  .feed-item--in { border-color: rgba(32,170,202,0.2); }
  .feed-item--out { border-color: rgba(244,63,94,0.2); }

  .feed-icon {
    width: 34px; height: 34px; border-radius: 10px;
    display: flex; align-items: center; justify-content: center;
    font-size: 14px; flex-shrink: 0;
  }
  .feed-icon--in { background: rgba(32,170,202,0.1); border: 1px solid rgba(32,170,202,0.2); }
  .feed-icon--out { background: rgba(244,63,94,0.1); border: 1px solid rgba(244,63,94,0.2); }
  .feed-icon--swap { background: rgba(99,102,241,0.1); border: 1px solid rgba(99,102,241,0.2); }

  .feed-info { flex: 1; min-width: 0; }
  .feed-name { font-size: 12px; font-weight: 600; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .feed-time { font-family: var(--font); font-size: 10px; color: var(--text-muted); margin-top: 2px; }

  .feed-amount { font-family: var(--font); font-size: 12px; font-weight: 700; white-space: nowrap; }
  .feed-amount--in { color: var(--green); }
  .feed-amount--out { color: var(--red); }

  /* Bottom row */
  .bottom-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }

  /* Table */
  .table-card {
    background: var(--surface); border: 1px solid var(--border);
    border-radius: 16px; padding: 28px;
    animation: fadeUp 0.8s ease 0.2s both;
    overflow-x: auto;
  }

  .data-table { width: 100%; border-collapse: collapse; margin-top: 4px; min-width: 480px; }
  .data-table th {
    font-family: var(--font); font-size: 10px; letter-spacing: 0.08em;
    text-transform: uppercase; color: var(--text-muted);
    padding: 8px 10px; text-align: left; font-weight: 700;
    border-bottom: 1px solid var(--border);
  }
  .data-table td {
    padding: 11px 10px; font-size: 12px;
    border-bottom: 1px solid rgba(255,255,255,0.03);
  }
  .data-table tr:last-child td { border-bottom: none; }
  .data-table tr:hover td { background: rgba(255,255,255,0.02); }

  .status-badge {
    display: inline-flex; align-items: center; gap: 5px;
    padding: 3px 9px; border-radius: 6px;
    font-family: var(--font); font-size: 10px; font-weight: 700;
  }
  .status-badge--completed { color: var(--green); background: rgba(32,170,202,0.1); }
  .status-badge--pending { color: var(--gold); background: rgba(245,158,11,0.1); }
  .status-badge--failed { color: var(--red); background: rgba(244,63,94,0.1); }
  .status-dot { width: 5px; height: 5px; border-radius: 50%; background: currentColor; }

  .mono { font-family: var(--font); }

  /* Progress bars card */
  .progress-card {
    background: var(--surface); border: 1px solid var(--border);
    border-radius: 16px; padding: 28px;
    animation: fadeUp 0.8s ease 0.25s both;
  }

  .progress-item { margin-bottom: 20px; }
  .progress-item:last-child { margin-bottom: 0; }
  .progress-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; }
  .progress-name { font-size: 12px; font-weight: 700; }
  .progress-pct { font-family: var(--font); font-size: 11px; font-weight: 700; color: var(--text-secondary); }
  .progress-track {
    height: 6px; border-radius: 100px;
    background: rgba(255,255,255,0.05);
    overflow: hidden;
  }
  .progress-fill {
    height: 100%; border-radius: 100px;
    transition: width 1s cubic-bezier(0.4,0,0.2,1);
  }
  .progress-meta { display: flex; justify-content: space-between; margin-top: 5px; }
  .progress-amount { font-family: var(--font); font-size: 10px; }

  /* Animations */
  @keyframes fadeUp {
    from { opacity: 0; transform: translateY(20px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @keyframes fadeDown {
    from { opacity: 0; transform: translateY(-12px); }
    to { opacity: 1; transform: translateY(0); }
  }
  @keyframes pulse-dot {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.4; }
  }
  @keyframes accountShimmer {
    to { background-position: -120% 0, 0 0; }
  }

  .kpi-card:nth-child(1) { animation-delay: 0.05s; }
  .kpi-card:nth-child(2) { animation-delay: 0.1s; }
  .kpi-card:nth-child(3) { animation-delay: 0.15s; }
  .kpi-card:nth-child(4) { animation-delay: 0.2s; }

  /* ── RESPONSIVE ── */

  /* Tablet: ≤1100px */
  @media (max-width: 1100px) {
    .content { padding: 24px 24px 48px; }
    .premium-grid { grid-template-columns: repeat(3, 1fr); }
    .kpi-grid { grid-template-columns: repeat(2, 1fr); }
    .mid-grid { grid-template-columns: 1fr 1fr; }
    .feed-card { grid-column: 1 / -1; }
    .bottom-grid { grid-template-columns: 1fr; }
    .kpi-value { font-size: 24px; }
  }

  /* Large mobile: ≤768px */
  @media (max-width: 768px) {
    .content { padding: 16px 16px 40px; }
    .header { margin-bottom: 28px; padding-bottom: 16px; }
    .header-title { font-size: 20px; }
    .premium-grid { grid-template-columns: repeat(2, 1fr); gap: 10px; }
    .kpi-grid { grid-template-columns: repeat(2, 1fr); gap: 12px; }
    .mid-grid { grid-template-columns: 1fr; gap: 12px; }
    .bottom-grid { gap: 12px; }
    .chart-card, .feed-card, .table-card, .progress-card { padding: 20px; }
    .kpi-card { padding: 18px; }
    .kpi-value { font-size: 22px; }
    .bar-chart { height: 110px; }
    .date-chip { display: none; }
  }

  /* Small mobile: ≤480px */
  @media (max-width: 480px) {
    .premium-grid { grid-template-columns: 1fr; }
    .premium-card-value { font-size: 18px; }
    .kpi-grid { grid-template-columns: 1fr 1fr; gap: 10px; }
    .kpi-value { font-size: 18px; letter-spacing: 0; }
    .kpi-card { padding: 14px; }
    .kpi-icon { width: 30px; height: 30px; font-size: 13px; }
    .header-title { font-size: 17px; }
    .bar-chart { height: 90px; }
    .orb-1, .orb-2, .orb-3 { display: none; }
  }
`;
